<template>

  <inventory-calendar-popup :title="title">

    <template v-slot:tools>

      <v-btn-group>
        <v-btn icon="$edit" :title="$t('actions.update_inventory')" @click="$emit('edit')" />
        <v-btn icon="$inventoryBreakdown" :title="$t('actions.view_breakdown')" @click="$emit('viewBreakdown')" />
      </v-btn-group>

    </template>

    <p>
      {{ item.eventName }} <template v-if="PreferencesService.preferences.showIds">({{ item.eventId }})</template><br>
      <strong>Parking Window:</strong> {{ item.parkingStart.toPlainTime().toLocaleString(undefined, {timeStyle: 'short'}) }} – {{ item.parkingEnd.toPlainTime().toLocaleString(undefined, {timeStyle: 'short'}) }}<br>
      <strong>Event Time:</strong> {{ item.eventStart.toPlainTime().toLocaleString(undefined, {timeStyle: 'short'}) }} – {{ item.eventEnd.toPlainTime().toLocaleString(undefined, {timeStyle: 'short'}) }}
    </p>

    <p class="mt-4 text-center">{{ item.spacesSold }}/{{ item.spacesTotal }}</p>

  </inventory-calendar-popup>

</template>

<script setup lang="ts">

import { computed } from 'vue'

// components
import InventoryCalendarPopup from './InventoryCalendarPopup.vue'
import type { MonthEventInventoryCalendarItem } from '../calendarItemTypes'

// misc
import PreferencesService from '../../../../../services/PreferencesService'

interface Props {
  item: MonthEventInventoryCalendarItem
}

const props = defineProps<Props>()

const $emit = defineEmits(['edit', 'viewBreakdown'])

const title = computed<string>(() => {
  let title = props.item.venueName
  if (PreferencesService.preferences.showIds) {
    title = `${title} (${props.item.venueId})`
  }
  return title
})

</script>
